// extracted by mini-css-extract-plugin
export default {"page":"page_SettingsPage-module_2Rp3Q","header":"header_SettingsPage-module_3m59b"};